import type { IconSvgObject } from './types';

const ChartLineData03Icon: IconSvgObject = [
  ["path", { d: "M21 8.33333C20.0748 7.03165 18.8647 6 16.9782 6C8.4681 6 10.9194 21 3 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartLineData03Icon;
